/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import Typography from '@mui/material/Typography';
import { GIT_HEAD, STAGE, VERSION } from '../../shared/utils/EnvironmentSettings';
import { Box, Paper } from '@mui/material';

class HomeView extends React.Component {
	titleStyle = { fontWeight: 300 };
	render(): JSX.Element {
		return (
			<Paper>
				<Typography variant="h1">
					<span style={this.titleStyle}>Willkommen </span>zur AdministrierBar!
				</Typography>
				<Box pt={1}>
					<Typography variant="body1" component="p">
						<span style={this.titleStyle}>Version </span> {VERSION}-{STAGE} ({GIT_HEAD})
					</Typography>
				</Box>
			</Paper>
		);
	}
}

export default HomeView;
